export default __webpack_public_path__ + "static/media/btn_motioncomics_default.5d5c8d12.png";